import React from 'react'

import logo from '../assets/images/logo.png';

const Header = (props) => (
    <header id="header" className="alt header-comp">
        <span className="logo"><img src={logo} alt="" /></span>
        <h1><span className="spotlight-head">Harmless</span> <b className="spot-bold">Noise</b></h1>
        <p>Having searched for the best new artists and songs in Ireland, they are bought here for you to enjoy.</p>
    </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js